module.exports = __webpack_public_path__ + "static/bc-772f431a0f8078797422ddfdfdd6dd4f.jpeg";